import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ProjectionMethodOption } from './projection-method-options';

/** Shared Revenue Projection explanation, embedded by every projection-method popover. */
@Component({
  selector: 'ag-shr-projection-method-help',
  standalone: true,
  templateUrl: './projection-method-help.component.html',
  styleUrls: ['./projection-method-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectionMethodHelpComponent {
  readonly option = input.required<ProjectionMethodOption>();
}
